
<ng-container *ngFor="let policy of policyDetails">
  <ng-container *ngIf="policy?.policynumber.policyNumber === policyId">
    <mapfre-alert></mapfre-alert>
    <header class="margin-bottom mb24">
      <ng-container *ngIf="isAcmic; else MAStatePaymentConfirmationMK">
        <div class="type-title">
          <h1 class="title">
            {{ 'MAKE_A_CHECK_PAYMENT' | translate }}
          </h1>
          <div class="sub-title">
            {{ policy?.displayType?.label | translate }} - <strong>{{ policy?.policynumber.policyNumber }}</strong>
          </div>
        </div>
      </ng-container>
      <ng-template #MAStatePaymentConfirmationMK>
      <h2 class="title dm-sans-medium mb-4">
        {{ 'MAKE_A_CHECK_PAYMENT' | translate }}
      </h2>
      <div class="sub-title" [ngClass]="achGuestPayConfirm ? 'text-center': ''">
        <img 
          src="{{policy?.displayType?.icon}}"
          width="40" height="40" 
          class="mr-2"
          alt="{{policy?.policyType?.toLowerCase()}} icon"
        />
        {{ policy?.displayType?.label | translate }} - {{ policy?.policynumber.policyNumber }}
      </div>
     </ng-template>       
    </header>
    <section class="row policy-details-content no-margin-horizontal details-content payment-success" >
      <div class="col col1 no-padding-left">  
      <div class="header-icon margin-bottom mb24 text-center">
      <ng-container *ngIf="isAcmic; else MAStatePCIconMK">
        <img src="./assets/img/images/icon-check-circle-acmic.svg" width="64" height="64" class="" alt="check circle icon" />
      </ng-container>
      <ng-template #MAStatePCIconMK>
        <img src="./assets/img/images/icon-check-circle-mapfre.svg" width="64" height="64" class="" alt="check circle icon" />
      </ng-template>
            <h2 class="title-copy text-center margin-top mt8">
              {{ "SUCCESSFUL_PAYMENT" | translate }}
            </h2>
            <h6 class="title-copy text-center grey-color confirm-payment">
                {{ 'Please, allow us up to 2 business days to process your payment and update your account' }}
            </h6>
            <div class="text-center margin-top mt24" *ngIf="achGuestPayConfirm">
              <a class="mapfre link red-link font-size medium-font"
              [routerLink]="['/make-payment']">
                 <strong> {{ "MAKE_ANOTHER_PAYMENT" | translate }} </strong>
              </a>
            </div> 
            
        </div>  
        <h2 class="title new-payment roboto-font" [ngClass]="isAcmic ? 'font-weight-500': 'dm-sans-medium'">
          {{ 'Summary' | translate }}
        </h2>
        <ng-container *ngIf="isAcmic; else maPaymentConfirmation">
          <div class="payment-confirmation">
            <div class="row margin-top mt24 margin-bottom mb16">
              <div class="col">
                  {{ 'PAYMENT_AMOUNT' | translate }}
              </div>
              <div class="col text-right">
                <strong>{{billing?.paymentAmount | currency }}</strong>
              </div>
            </div>
            <div class="row margin-bottom mb16">
              <div class="col">
                  {{ 'BANK_ACCOUNT_NUMBER' | translate }}
              </div>
              <div class="col text-right">
                  <strong>{{billing?.bankAccount?.accountNumber.digits | maskAccountNumber}}</strong>
              </div>
            </div>
            <div class="row margin-bottom mb16">
              <div class="col">
                  {{ 'CHECK_NUM' | translate }}
              </div>
              <div class="col text-right">
                <ng-container *ngIf="billing?.checkNumber === ''">
                    <strong>N/A</strong>
                </ng-container>
                <ng-container *ngIf="billing?.checkNumber !== '' ">
                    <strong>{{billing?.checkNumber}}</strong>
                </ng-container>
              </div>
            </div>
            <div class="row margin-bottom mb16">
              <div class="col">
                {{ 'ROUTING_NUMBER' | translate }}
              </div>
              <div class="col text-right">
                  <strong>{{billing?.bankAccount?.routingNumber.digits}}</strong>
              </div>
            </div>
            <div class="row margin-bottom mb16">
              <div class="col">
                  {{ 'HOLDER_NAME' | translate }}
              </div>
              <div class="uppercase col text-right">
                  <strong>{{billing?.bankAccount?.accountHolderName | titlecase}}</strong>
              </div>
            </div>
            <div class="row margin-bottom mb16" *ngIf="policyId.length !== 10">
              <div class="col">
                  {{ 'MAILING_ADDRESS' | translate }}
              </div>
              <div class="col text-right">
                  <strong>{{billing?.bankAccount?.mailingAddress?.streetName.replace('#',', APT ')}} {{ billing?.bankAccount?.mailingAddress.city }}, {{ billing?.bankAccount?.mailingAddress?.state }}, {{ billing?.bankAccount?.mailingAddress?.zipCode.code }}</strong>
                </div>
            </div>
          </div>
        </ng-container>
        <ng-template #maPaymentConfirmation>
          <div class="payment-confirmation">
            <div class="row margin-top mt24">
              <div class="col">
                  {{ 'PAYMENT_AMOUNT' | translate }}
              </div>
              <div class="col mk-txt-left">
                <strong>{{billing?.paymentAmount | currency }}</strong>
              </div>
            </div>
            <div class="row ">
              <div class="col">
                  {{ 'BANK_ACCOUNT_NUMBER' | translate }}
              </div>
              <div class="col mk-txt-left">
                  <strong>{{billing?.bankAccount?.accountNumber.digits | maskAccountNumber}}</strong>
              </div>
            </div>
            <div class="row">
              <div class="col">
                  {{ 'CHECK_NUM' | translate }}
              </div>
              <div class="col mk-txt-left">
                <ng-container *ngIf="billing?.checkNumber === ''">
                    <strong>N/A</strong>
                </ng-container>
                <ng-container *ngIf="billing?.checkNumber !== '' ">
                    <strong>{{billing?.checkNumber}}</strong>
                </ng-container>
              </div>
            </div>
            <div class="row">
              <div class="col">
                {{ 'ROUTING_NUMBER' | translate }}
              </div>
              <div class="col mk-txt-left">
                  <strong>{{billing?.bankAccount?.routingNumber.digits}}</strong>
              </div>
            </div>
            <div class="row">
              <div class="col">
                  {{ 'HOLDER_NAME' | translate }}
              </div>
              <div class="uppercase col mk-txt-left">
                  <strong>{{billing?.bankAccount?.accountHolderName | titlecase}}</strong>
              </div>
            </div>
            <div class="row" *ngIf="policyId.length !== 10">
              <div class="col">
                  {{ 'MAILING_ADDRESS' | translate }}
              </div>
              <div class="col mk-txt-left">
                  <strong>{{billing?.bankAccount?.mailingAddress?.streetName.replace('#',', APT ')}} {{ billing?.bankAccount?.mailingAddress.city }}, {{ billing?.bankAccount?.mailingAddress?.state }}, {{ billing?.bankAccount?.mailingAddress?.zipCode.code }}</strong>
                </div>
            </div>
          </div>
        </ng-template>        

        <div class="mt-4 text-center" *ngIf="achGuestPayConfirm">

        <span class="margin-right mr16" style="display:inline-block" *ngIf="isAcmic">
          <svg-mailing-fast-svg></svg-mailing-fast-svg> 
        </span>
        <span class="margin-right mr16" style="display:inline-block" *ngIf="!isAcmic">
          <img src="./assets/img/images/icon-payment-convenience.svg" width="32" height="32" alt="payment convenience" />
        </span>
        
        <div
          class=" text-center disclaimer disclaimer-large-size legal margin-vertical mv16"
          [ngClass]="{'mk-payment': !isAcmic}">
          {{ "ACCESS_CUSTOMER_PORTAL_VIEW_BILLING" | translate }}
          <br />
          <ng-container *ngIf="isAcmic; else MAStatePCLegalMK">
          <span>
            {{ "Log into " | translate }}
          </span>
          <strong>
            <a class="link-button blue-link" [routerLink]="['/login']">{{
              "My Account" | translate
            }}</a>
          </strong>
          </ng-container>
          <ng-template #MAStatePCLegalMK>
            <br />
            <span>
              {{ "Log into " | translate }}
            </span>
            <strong>
              <a class="mt-3 link-button mapfre link dm-sans-medium red-link" [routerLink]="['/login']">{{
                "My account" | translate
              }}</a>
            </strong>
          </ng-template>
        </div>
        <div
          class="text-center disclaimer disclaimer-large-size legal margin-vertical mv16"
          [ngClass]="{'mk-payment': !isAcmic}">
          {{ "No online account yet?" | translate }}
          <br />
          <strong>
          <ng-container *ngIf="isAcmic; else MAStateCreateYourAcctMK">
            <a class="link-button blue-link" [routerLink]="['/signup']">
              {{"Create Your Account" | translate}}
          </a>
          </ng-container>
          <ng-template #MAStateCreateYourAcctMK>
            <a class="link-button mapfre link dm-sans-medium red-link" [routerLink]="['/signup']">
              {{"Create your account" | translate}}
          </a>
          </ng-template>
          </strong>
        </div>
        </div>

        <div class="text-center margin-top mt24 mb24" *ngIf="!achGuestPayConfirm">
          <ng-container *ngIf="isAcmic; else maGotoBilling">
            <a class="mapfre link red-link"
            [routerLink]="['/my-insurance/'+policyId+'/billing']">
               <strong> {{ 'GO_TO_BILLING' | translate }} </strong>
            </a>
          </ng-container>
          <ng-template #maGotoBilling>
            <mapfre-button
                [additionalClasses]="'basic primary large-btn center-button  waves-effect'"
                [routerLink]="['/my-insurance/'+policyId+'/billing']">
                {{ 'GO_TO_BILLING' | translate }}
              </mapfre-button>            
          </ng-template>            
        </div>       
      </div>
      <div class="col col2" *ngIf="!achGuestPayConfirm">
        <app-billing-sidebar [policy]="policy"></app-billing-sidebar>
      </div>
    </section>
  </ng-container>
</ng-container>
